import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, CaretDown } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import logo from "../../assets/logo.png";

const navLinks = [
  {
    label: "Solutions",
    children: [
      // { label: "Design Your Plan", href: "/design-your-plan", highlight: true },
      { label: "Insurance Rail", href: "/rails/insurance" },
      { label: "Wallet Pool Management", href: "/rails/wallet-pool" },
      { label: "Reimbursement Rail", href: "/rails/reimbursement" },
      { label: "Zero Budget Access", href: "/rails/zero-budget" },
      { label: "Health Credit Facility", href: "/rails/health-credit" },
      { label: "Wellness and Preventive", href: "/rails/wellness" },
    ],
  },
  {
    label: "Calculators",
    children: [
      { label: "Design Your Plan", href: "/design-your-plan", highlight: true },
      { label: "Quick Cost Estimator", href: "/calculators/quick" },
      { label: "Advanced Calculator", href: "/calculators/advanced" },
      { label: "Insurance Premium Estimator", href: "/calculators/insurance" },
    ],
  },
  { label: "About", href: "/#about" },
];

export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 liquid-glass-header">
      <nav className="container-full">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            {/* <div className="w-8 h-8 bg-[#0048ff] rounded-lg flex items-center justify-center"> */}
            <img
              src={logo}
              alt="Mentor Health"
              className="text-white font-bold text-lg"
            />
            {/* </div> */}
            {/* <span className="font-semibold text-xl text-[#11111f]">Mentor Health</span> */}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link, idx) => (
              <div key={idx} className="relative group">
                {link.children ? (
                  <button
                    className="flex items-center gap-1 text-[#11111f]/70 hover:text-[#0048ff] transition-colors py-2 font-medium"
                    onMouseEnter={() => setOpenDropdown(idx)}
                    onMouseLeave={() => setOpenDropdown(null)}
                  >
                    {link.label}
                    <CaretDown size={14} weight="bold" />
                  </button>
                ) : (
                  <Link
                    to={link.href}
                    className="text-[#11111f]/70 hover:text-[#0048ff] transition-colors py-2 font-medium"
                  >
                    {link.label}
                  </Link>
                )}
                {link.children && (
                  <div
                    className={`absolute top-full left-0 pt-2 transition-all duration-200 ${
                      openDropdown === idx
                        ? "opacity-100 visible"
                        : "opacity-0 invisible"
                    }`}
                    onMouseEnter={() => setOpenDropdown(idx)}
                    onMouseLeave={() => setOpenDropdown(null)}
                  >
                    <div className="bg-white/95 backdrop-blur-2xl border border-white/40 rounded-xl shadow-2xl p-2 min-w-[240px] overflow-hidden">
                      {link.children.map((child, childIdx) => (
                        <Link
                          key={childIdx}
                          to={child.href}
                          className={`block px-4 py-2.5 rounded-lg transition-all duration-200 ${
                            child.highlight
                              ? "text-[#0048ff] font-bold bg-[#0048ff]/5 hover:bg-[#0048ff]/10"
                              : "text-[#11111f] hover:text-[#0048ff] hover:bg-[#F8F9FB]"
                          }`}
                        >
                          {child.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <Link to="/demo">
              <Button
                variant="outline"
                className="border-[#0048ff] text-[#0048ff] hover:bg-[#0048ff] hover:text-white rounded-lg"
                data-testid="nav-demo-btn"
              >
                Request Demo
              </Button>
            </Link>
            <Link to="/register">
              <Button
                className="bg-[#0048ff] hover:bg-[#003bce] rounded-lg"
                data-testid="nav-register-btn"
              >
                Register Company
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? (
              <X size={24} weight="light" />
            ) : (
              <List size={24} weight="light" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-6 border-t border-white/10 bg-white/80 backdrop-blur-2xl rounded-b-2xl shadow-2xl animate-fade-in px-4">
            {navLinks.map((link, idx) => (
              <div key={idx} className="py-2">
                {link.children ? (
                  <>
                    <button
                      className="flex items-center justify-between w-full text-[#11111f]/70 py-2 font-medium"
                      onClick={() =>
                        setOpenDropdown(openDropdown === idx ? null : idx)
                      }
                    >
                      {link.label}
                      <CaretDown
                        size={14}
                        weight="bold"
                        className={`transition-transform ${openDropdown === idx ? "rotate-180" : ""}`}
                      />
                    </button>
                    {openDropdown === idx && (
                      <div className="pl-4 mt-2 space-y-2">
                        {link.children.map((child, childIdx) => (
                          <Link
                            key={childIdx}
                            to={child.href}
                            className={`block py-2 ${child.highlight ? "text-[#0048ff] font-medium" : "text-[#11111f]/60 hover:text-[#0048ff]"}`}
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            {child.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={link.href}
                    className="block text-[#11111f]/70 py-2 font-medium"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.label}
                  </Link>
                )}
              </div>
            ))}
            <div className="flex flex-col gap-3 mt-4 pt-4 border-t border-[#E5E7EB]">
              <Link to="/demo" onClick={() => setMobileMenuOpen(false)}>
                <Button
                  variant="outline"
                  className="w-full border-[#0048ff] text-[#0048ff] rounded-lg"
                >
                  Request Demo
                </Button>
              </Link>
              <Link to="/register" onClick={() => setMobileMenuOpen(false)}>
                <Button className="w-full bg-[#0048ff] rounded-lg">
                  Register Company
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
